import { render, staticRenderFns } from "./CoursewareContentBookmarkFilterWidget.vue?vue&type=template&id=7654ded0&"
import script from "./CoursewareContentBookmarkFilterWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareContentBookmarkFilterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports